export default "__VITE_ASSET__CugfcCHL__"